<template>
    <v-dialog v-model="dialog" max-width="500px">
        <v-card>
            <v-card-title class="text-h5 aviso" style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    ">
                {{ fichaje_id != null ? 'Editar Fichaje' : 'Crear fichaje manual' }}
            </v-card-title>
            <v-card-text style="text-align: center">
                <v-row>
                    <v-col cols="12" md="6">
                        <v-autocomplete label="Empleado" v-model="data.usuario_id" :items="empleados" item-value="id"
                            item-text="name"></v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field type="number" label="Horas" v-model="data.horas"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field type="number" label="Horas nocturnas" v-model="data.horas_extras"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="pt-3">
                <v-spacer></v-spacer>

                <v-btn color="error" large @click="dialog = false">Cancelar</v-btn>
                <v-btn v-if="fichaje_id == null" color="success" large @click="Fichar()">Confirmar</v-btn>
                <v-btn v-else color="success" large @click="EditarFichaje()">Editar</v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>

export default {
    props: ['orden', 'value', 'fichaje'],
    data() {
        return {
            dialog: false,
            empleados: [],
            data: {
                usuario_id: null,
                horas: null,
                horas_extras: null
            },
            fichaje_id: null,
        }
    },
    watch: {
        value(val) {
            this.dialog = val;
        },
        dialog(val) {
            this.$emit('input', val);
        },
        fichaje(val) {
            this.fichaje_id = val.id;
            this.data.usuario_id = val.usuario_id;
            this.data.horas = val.horas;
            this.data.horas_extras = val.horas_extras;
        }
    },
    created() {
        this.getUsuarios();
        if (this.value != null) {
            this.dialog = this.value;
        }
    },
    methods: {
        getUsuarios() {
            axios.get(`api/get-usuarios?empleado=true`).then(
                (res) => {
                    //console.log(res.data.users);
                    this.empleados = res.data.users;
                    //console.log(this.Usuarios);
                },
                (err) => {
                    this.$custom_error("Error consultando Usuario");
                }
            );
        },
        async Fichar() {
            try {
                const res = await axios.post(`api/orden/fichaje/manual`, {
                    orden_id: this.orden.id,
                    usuario_id: this.data.usuario_id,
                    horas: this.data.horas,
                    horas_extras: this.data.horas_extras
                });
                this.$emit('Saved', res.data);
                this.dialog = false;
            } catch (ex) {

            }
        },
        async EditarFichaje() {
            try {
                const res = await axios.put('api/editar-orden-manual/'+this.fichaje_id, {
                    orden_id: this.orden.id,
                    usuario_id: this.data.usuario_id,
                    horas: this.data.horas,
                    horas_extras: this.data.horas_extras
                });
                this.$emit('Saved', res.data);
                this.dialog = false;
            } catch (ex) {
                console.log(ex);
            }
        },
    }
}
</script>